import React from 'react'
import type { Icon } from 'shared/utils'

const CircleMap = (props: Icon) => {
    const { color = 'white', size = 24, className = 'circle-map' } = props
    return (
        <svg
            fill={color}
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <g fillRule="evenodd">
                <path
                    d="M12 23.1c6.13 0 11.1-4.97 11.1-11.1S18.13.9 12 .9.9 5.87.9 12 5.87 23.1 12 23.1zm0 .9C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
                    fillRule="nonzero"
                />
                <path d="M12 19.052a.636.636 0 0 1-.471-.21c-.504-.56-4.929-5.548-4.929-8.342 0-2.978 2.423-5.4 5.4-5.4 2.977 0 5.4 2.422 5.4 5.4 0 2.794-4.425 7.783-4.929 8.343a.636.636 0 0 1-.471.209zm0-6.738a2.342 2.342 0 0 0 2.339-2.34A2.342 2.342 0 0 0 12 7.637a2.341 2.341 0 0 0-2.339 2.338c0 1.29 1.05 2.339 2.339 2.339z" />
            </g>
        </svg>
    )
}

export { CircleMap }
